/* eslint-disable semi */
/* eslint-disable prefer-destructuring */
import { TextField, TextFieldProps, TextFieldState } from './TextField'
import { formatDigits } from '../Utility';

export function isAbn(value: string) {
  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  const abn = value.replace(/[^\d]/g, '');
  let result = false;

  if (abn.length === 11) {
    let sum = 0;
    let weight;

    for (let index = 0; index <= weights.length - 1; index++) {
      weight = weights[index];
      const digit = (abn[index] as any) - (index ? 0 : 1);
      sum += weight * digit;
    }

    result = sum % 89 === 0;
  }

  return result;
}

export class AbnOrAnyField extends TextField {
  componentDidMount() {
    const { value, selectedCountry } = this.props;

    // does it appear to be an ABN, if so format it straight up
    if (value && selectedCountry === 'Australia' && value.match(/^\d+$/) && value.replace(/\s/g, '').length === 11) {
      this.setState({ value : formatDigits(value) })
    }
  }

  componentDidUpdate(prevProps: TextFieldProps, prevState: TextFieldState) {
    if (prevState.value !== this.state.value) {
      const currErrorMsg = super.getErrorMessage();
      if (currErrorMsg && currErrorMsg != '') {
        super.setError('') // clear the error, because the validation message no longer applies.
      }
    }
  }

  onBlurHandler(v: string) {
    const selectedCountry = this.props.selectedCountry;

    // apply formatting only if Australia, therefore ABN in use
    const formattedVal = selectedCountry === 'Australia' ? formatDigits(v) : v;
    super.onBlurHandler(formattedVal);
  }
}
